import { useLocation } from "react-router-dom";
import { parseQueryParams } from "../url/parse_query_params";

export function useQueryParams() {
    const { search } = useLocation();
    const { dgid, effort, page } = parseQueryParams(search);
    return { dgid, effort, page };
}
